import { getMimeTypeFromFileName } from '@frameio/utils/files/fileExtensionHelpers';
import { getDisplayCategory } from '@frameio/utils/files/fileTypeHelpers';
import type { Asset } from '../generated/types';
import type { AssetTypename } from './types/AssetTypename';

export type DisplayAsset = Partial<Pick<Asset, 'name'>> & {
  __typename?: AssetTypename;
  media?: {
    __typename?: string;
  } | null;
};

export const getDisplayCategoryForAsset = (asset: DisplayAsset) => {
  const fileType = getMimeTypeFromFileName(asset.name);

  if (asset.__typename === 'InteractiveLiveAsset') {
    return getDisplayCategory(fileType, 'InteractiveLiveMedia');
  }

  if (asset.media) {
    return getDisplayCategory(fileType, asset.media.__typename);
  }

  return getDisplayCategory(fileType);
};
